import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from "react";
import classNames from "classnames";
import { Controller, useFormContext } from "../../../components/Form";
import { TextInput } from "../../../components/Inputs";
import { InputInfoSection } from "../../../components/Inputs/components/InputWrapper/InputInfoSection";
import { InputLabel } from "../../../components/Inputs/components/InputWrapper/InputLabel";
import { Select } from "../../../components/Inputs/Select/Select";
import { useConfig } from "../../../providers/useConfig";
import { useTranslations } from "../../../providers/useTranslations";
import { getCountriesCodesArray } from "../../../utils/countryCode/countryCode";
import { validationPatterns } from "../../../utils/validationPatterns";
import styles from "./RegularTelephone.module.scss";
export const validatePhone = (e) => {
    const isNotNumber = isNaN(Number(e.key));
    const specialKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Enter", "Tab"];
    const isKeyAllowed = specialKeys.includes(e.code) || specialKeys.includes(e.key);
    const isKeyNotAllowed = e.code === "Space" || e.key === " ";
    if (isKeyAllowed) {
        return true;
    }
    if (isNotNumber || isKeyNotAllowed) {
        e.preventDefault();
        return false;
    }
};
const onBeforeInputHandler = (event) => {
    const inputValue = event.nativeEvent.data;
    const isNotNumber = isNaN(Number(inputValue));
    if (isNotNumber) {
        event.preventDefault();
    }
};
export const RegularTelephone = memo(({ showLabel = true, fieldName = (name) => name, isRequired = true, isWithoutDropdown, isDisabled = false, isInfoMessageVisible = false, isPhoneFieldFullWidth, }) => {
    const { __ } = useTranslations();
    const config = useConfig();
    const { getValues, control } = useFormContext();
    const DEFAULT_PHONE_NUMBER_LENGTH = 12;
    const prefixLength = getValues(fieldName("code"))?.value?.length || 0;
    const maxPhoneNumber = +config.PHONE_NUMBER_MAX_LENGTH || DEFAULT_PHONE_NUMBER_LENGTH;
    const minPhoneNumber = +config.PHONE_NUMBER_MIN_LENGTH || DEFAULT_PHONE_NUMBER_LENGTH;
    const pattern = {
        pattern: {
            message: __("form_validation.phone_number_pattern"),
            value: validationPatterns.PHONE_NUMBER,
        },
        minLength: {
            value: minPhoneNumber - prefixLength,
            message: __("form_validation.phone_number_pattern"),
        },
        maxLength: {
            value: maxPhoneNumber - prefixLength,
            message: __("form_validation.phone_number_pattern"),
        },
    };
    const validationRules = isRequired
        ? {
            ...pattern,
            required: __("form_validation.field_required"),
        }
        : pattern;
    const countriesCodesArray = React.useMemo(() => getCountriesCodesArray(config), [config]);
    const renderPrefixDropdown = () => {
        if (!isWithoutDropdown) {
            return (_jsx("div", { className: styles.code, children: _jsx(Controller, { control: control, defaultValue: countriesCodesArray[0], name: fieldName("code"), render: ({ field }) => (_jsx(Select, { ...field, dataTestId: "prefixDropdown", isSearchable: false, "aria-label": __("contact_info.phone_number"), placeholder: __("contact_info.phone_code_placeholder"), options: countriesCodesArray, isDisabled: isDisabled, isIconHidden: true })) }) }));
        }
        return null;
    };
    const maxPhoneNumberLength = !isWithoutDropdown ? maxPhoneNumber - prefixLength : undefined;
    const label = isWithoutDropdown
        ? __("contact_info.phone_number_without_dropdown")
        : __("contact_info.phone_number");
    return (_jsx("div", { className: styles.phoneSelectBlock, children: _jsxs("div", { className: styles.phoneContainer, children: [showLabel && (_jsx(InputLabel, { id: "phoneLabelId", htmlFor: "phoneLabelId", children: `${label} ${isRequired ? "*" : ""}` })), _jsxs("div", { className: styles.control, children: [renderPrefixDropdown(), _jsx("div", { className: classNames({ [styles.telephoneFullWidth]: isWithoutDropdown || isPhoneFieldFullWidth }), onKeyDown: validatePhone, children: _jsx(Controller, { control: control, name: fieldName("phone"), render: ({ field, fieldState }) => (_jsx(TextInput, { ...field, "aria-labelledby": "phoneLabelId", dataTestId: "phoneInput", placeholder: __("contact_info.phone_placeholder"), type: "text", maxLength: maxPhoneNumberLength, disabled: isDisabled, isError: !!fieldState?.error, errorText: fieldState?.error?.message, isHelperTextVisible: !!fieldState?.error, onBeforeInput: onBeforeInputHandler })), rules: validationRules, defaultValue: "" }) })] }), isInfoMessageVisible && _jsx(InputInfoSection, { text: __("profile.phone_update_page.otp.input.format") })] }) }));
});
//# sourceMappingURL=RegularTelephone.js.map